import React, { FC, useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Dialog, Button, Checkbox } from '@material-ui/core'
import useStore from 'store'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon } from 'ui'
import { observer } from 'mobx-react'
import "firebase/analytics"
import firebase from "firebase/app"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const ContainerDialog = styled.div`
    align-items:center;
    justify-content:space-around;
    flex-direction:column;
    display:flex;
    background-color:${theme.color.whiteBackground};
    padding:20px 20px;
    overflow:auto;
    max-height:900px;
    width:600px;
`
const AlwaysActiveContainer = styled.div`
  color: ${theme.color.communityBlue};
`

const CookieModal: FC = () => {
    const { t } = useTranslation('cookies')
    const { modulesStore } = useStore()
    const [showCustomCookies, setCustomCookies] = useState(false)
    const [showTargetCookie, setShowTargetCookie] = useState(true)
    const open = modulesStore.cookiePolicyModalOpenState

    const closeModal = () => {
      modulesStore.closeCookiePolicyModal()
    }

    const updateCookiePolicy = (data: any) => {
      localStorage.setItem('@cookie_consent', JSON.stringify(data));
      modulesStore.cookiePolicyPresentState = true
      if (data.statistics) {
        try {
          firebase.initializeApp({
            apiKey: "AIzaSyAQT_cb0iRVbPK-lmHLJaZgqwaFaJJGxAc",
            authDomain: "soy-zone-750.firebaseapp.com",
            databaseURL: "https://soy-zone-750.firebaseio.com",
            projectId: "soy-zone-750",
            storageBucket: "soy-zone-750.appspot.com",
            messagingSenderId: "464930886928",
            appId: "1:464930886928:web:a348cb93f215f2f4f7c195",
            measurementId: "G-3X7VNQ762T"
          });
                       
          firebase.analytics();
        }
        catch (e) {
          console.log("firebase.initializeApp error", e)
        }
      }
    }
    
    return (
      <Dialog style={{ zIndex: 1200 }}  maxWidth="sm" open={open} onBackdropClick={closeModal}>
        <ContainerDialog>    
          <Row style={{ padding: 10, width: '90%', justifyContent: 'space-between' }}>
            <Button variant="contained" size="small" style={{ width: '100%' }} onClick={() => {
              setShowTargetCookie(false)
              updateCookiePolicy({ 
                necessary: true,
                statistics: false
              })
              closeModal()
            }}>{t`necessary_cookies_only`}</Button>
          </Row>

          <Row style={{  padding: 10,  width: '90%' }}>
            <Button variant="outlined" size="small" style={{ width: '100%' }} onClick={() => { setCustomCookies(!showCustomCookies) }}>{t`customise_settings`}</Button>
          </Row>

         {showCustomCookies && 
         <>
          <Row style={{  padding: 10,  width: '90%' }}>  
            <TableContainer>
              <Table  aria-label="simple table">
                <TableBody>
                  <TableRow key="necessary_c">
                    <TableCell align="right">
                      <AlwaysActiveContainer>
                        {t`always_active`}
                      </AlwaysActiveContainer>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {t`necessary_cookies_only`}
                    </TableCell>
                  </TableRow>

                  <TableRow key="targeting_c">
                    <TableCell align="right">
                      <Checkbox 
                        checked={showTargetCookie}
                        onChange={(e) => {
                          setShowTargetCookie(e.target.checked)
                        }}
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {t`statistics`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Row>
          <Row style={{  padding: 10,  width: '90%' }}>
            <Button  variant="contained" size="small" style={{ width: '100%'}} onClick={() => {
              setShowTargetCookie(true)
              updateCookiePolicy({ 
                necessary: true,
                statistics: showTargetCookie
              })
              closeModal()
            }}>
              {t`confirm_my_choice`}
            </Button> 
          </Row>
          </>}
        </ContainerDialog>
      </Dialog>
    )
}

export default observer(CookieModal)


